import type { Market } from 'src/interfaces/market'

/**
 * In-memory search over the markets list. Returns the input array by reference for an empty
 * query so an untouched search box does not churn the caller's `useMemo`.
 */
export const filterMarkets = (markets: Market[], search: string): Market[] => {
  const normalizedSearch = search.trim().toLowerCase()

  if (normalizedSearch === '') {
    return markets
  }

  return markets.filter((market) => {
    const haystack = [market.title, market.description ?? '']

    return haystack.some((value) => {
      return value.toLowerCase().includes(normalizedSearch)
    })
  })
}
